class Sticky {

    /**
     * @since 5.0.0
     * @method constructor
     */
    constructor() {
        // Declare and initialize
        this.event         = 'scroll.sticky-onscroll resize.sticky-onscroll';
        this.sticker       = 'is-sticky';
        this.sticking      = 'is-sticking';
        this.selector      = '[data-toggle="sticky-onscroll"]';
        this.wrapperClass  = 'sticky-wrapper';
        this.wrap          = false;
        this.scrollTimeout = null;

        // Run re-initialization if the screen gets resized
        $(window).resize(() => {

            // This is the re-initialization we were talking about
            this.init();

        });

        // Run initialization after a delay
        setTimeout(() => this.init(), 250);
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 5.0.0
     * @returns void
     */
    init() {

        'use strict';

        // Declare and initialize
        var self = this;

        // Find all data-toggle="sticky-onscroll" elements
        $(this.selector).each((i, ele) => {

            // Declare and initialize
            var sticky  = $(ele);
            var wrapper = null;

            // Only run the offset if the screen is too small
            if ($(window).width() < 769) return;

            // Male a wrapper if we need one
            if (this.wrap)
                wrapper = $('<div>').addClass(this.wrapperClass);

            // Inject our placeholder right next to the sticky
            if (this.wrap) sticky.before(wrapper);

            // Make our sticky sticky
            sticky.addClass('sticky');

            // Scroll & resize events
            $(window).on(this.event, (e) => {

                // Run the toggle logic
                self.toggle(sticky, wrapper, $(e.currentTarget));

                // Reset the debounce timer
                clearTimeout(self.scrollTimeout);

                // Set a debounce timer
                self.scrollTimeout = setTimeout(() => {
                    self.toggle(sticky, wrapper, $(window));
                }, 200);

            });

            // On page load
            this.toggle(sticky, wrapper, $(window));

        });

    }

    /**
     * Toggle the sticky situation.
     *
     * @method toggle
     * @since 5.0.0
     * @param object sticky is the sticky object
     * @param object wrapper is the placeholder wrapper
     * @param object element is that which is referenced in scroll
     * @returns void
     */
    toggle(sticky = null, wrapper = null, element = null) {
        // Declare and initialize
        let viewPortScroll = $(document).scrollTop();
        let elementOffset  = $(sticky).data('sticky-offset-top');
        let adminBarOffset = $('#wpadminbar').height() || 0;

        // If there is no offset, set it
        if (!elementOffset) {

            // Temporarily change this to a static position
            sticky.css('position', 'static');

            // Set the true offset
            sticky.data('sticky-offset-top', sticky.offset().top);

            // Revert back to the original
            sticky.css('position', '');

            // Try that again
            elementOffset = $(sticky).data('sticky-offset-top');

        }

        // Offset the viewport scroll position
        if (!!adminBarOffset)
            viewPortScroll += adminBarOffset;

        // Emit an event
        sticky.trigger('stickToggleStart');

        // Toggle the stickiness
        if (viewPortScroll > elementOffset) {

            // Add our sticker class
            sticky.addClass(this.sticker);

            // Set our flood class
            sticky.addClass(this.sticking);

            // Remove our flood class
            setTimeout(() => {
                sticky.removeClass(this.sticking);
            }, 3000);

            // Run the class toggler
            this.toggleClass(sticky, 'on');

            // Emit an event
            sticky.trigger('stickToggleOn');

        } else {

            // Unstick our stickered sticky
            sticky.removeClass(this.sticker);

            // Remove our flood class
            sticky.removeClass(this.sticking);

            // Run the class toggler
            this.toggleClass(sticky, 'off');

            // Emit an event
            sticky.trigger('stickToggleOff');
        }

    }

    /**
     * Toggle classes inside the sticky.
     *
     * @since 5.0.25
     * @method toggleClass
     * @param object sticky is the current sticky element
     * @param string $type is the type of toggling to do
     * @return void
     */
    toggleClass(sticky = null, type = 'on') {
        // Declare and initialize
        let selector = '[data-sticky-toggle-class-from]';
        let excluder = 'sticky-class-toggle-ignore';
        let togglees = sticky.find(selector + ':not(.' + excluder + ')');

        // If there aren't any, go home
        if (1 > togglees.length)
            return;

        // Run through them
        togglees.each(function (index, element) {

            // Declare and initialize
            let ele  = $(element);
            let from = ele.data('sticky-toggle-class-from');
            let to   = ele.data('sticky-toggle-class-to');

            // Check if we should process this
            if (!ele.hasClass('sticky-toggle-class-processed')) {

                // If it does not have the initial class, ignore it
                if (!ele.hasClass(from)) {

                    // SHAME! SHAME! SHAME!
                    ele.addClass(excluder)

                    // Away with thee
                    return;

                }

            }

            // Set the processor class
            ele.addClass('sticky-toggle-class-processed');

            // Toggle the class on
            if ('on' === type && ele.hasClass(from))
                ele.removeClass(from).addClass(to);

            // Toggle the class off
            if ('off' === type && ele.hasClass(to))
                ele.removeClass(to).addClass(from);

        });
    }
}

export default Sticky;